import React, { Component } from 'react';
import { Grid, Cell } from 'react-mdl';

class Experience extends Component {
    render() {
        const endYear = this.props.endYear || 'Present';

        return (
            <Grid className="timeline-row">
                <Cell col={4} tablet={4} phone={12} className="timeline-date">
                    <p>
                        {this.props.startYear} - {endYear}
                    </p>
                </Cell>
                <Cell col={8} tablet={8} phone={12} className="timeline-detail">
                    <h4 className="timeline-title">{this.props.jobName}</h4>
                    <p className="timeline-role-title">{this.props.jobDescription}</p>
                    <p className="timeline-role-detail">{this.props.jobRole}</p>
                </Cell>
            </Grid>
        );
    }
}

export default Experience;
